import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  formContainer: {
    [`${theme.breakpoints.up("sm")}`]: {
      display: "flex",
      gap: "16px"
    },
  },
  newLabel: {
    backgroundColor: "rgba(242, 243, 247, 0.5)",
    color: theme.palette.grey.grey500,
    fontWeight: 700,
    border: 0,
    padding: "8px 16px",
    borderRadius: "16px",
    fontSize: "14px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineClamp: 1,
    boxOrient: "vertical",
    whiteSpace: "nowrap",
    lineHeight: "200%",
    maxWidth: "100%",
  },
}));

export default useStyles;
